<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

interface WhyCard {
  id: string
  title: string
  description: string
}

const cards = computed<WhyCard[]>(() => [
  {
    id: 'innovation',
    title: t('innovative_technologies'),
    description: t('innovative_technologies_description'),
  },
  {
    id: 'simplicity',
    title: t('ease_of_use'),
    description: t('ease_of_use_description'),
  },
  {
    id: 'efficiency',
    title: t('high_efficiency'),
    description: t('high_efficiency_description'),
  },
  {
    id: 'support',
    title: t('technical_support'),
    description: t('technical_support_description'),
  },
])
</script>

<template>
  <section class="bg-white py-8 md:py-20">
    <div class="container mx-auto flex flex-col gap-4 lg:gap-10">
      <h2
        data-aos="fade-up"
        data-aos-duration="800"
        data-aos-delay="100"
        class="font-semibold text-[32px] sm:text-4xl md:text-5xl text-[#172026] text-center leading-10 md:leading-[72px]"
      >
        {{ $t("why_choose_us") }}
      </h2>
      <div
        class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4 md:gap-5 lg:gap-7"
      >
        <div
          v-for="(card, index) in cards"
          :key="card.id"
          :data-aos="index < 2 ? 'fade-up' : 'fade-up'"
          :data-aos-duration="800"
          :data-aos-delay="200 + index * 100"
          class="bg-[#F4F8FA] rounded-2xl md:rounded-2xl py-8 px-6"
        >
          <h3 class="font-semibold text-xl leading-[130%] text-[#172026] mb-4">
            {{ card.title }}
          </h3>
          <p
            class="font-normal text-sm leading-[150%] sm:text-base text-[#36485C]"
          >
            {{ card.description }}
          </p>
        </div>
      </div>
    </div>
  </section>
</template>
